import React from "react";
import PropTypes from "prop-types";
import { withStyles, withTheme } from "@material-ui/core";
import { withTranslation } from "react-i18next";
import { DateService } from "../../../../services/dates.service";
import Typography from "../../../../components/Helpers/Typography";
import { vehicleHistoryStyles } from "./sharedStyles";
import { TimelineStatus } from "../../../../services/timeline.service";

const TimelineStatusHeaderRow = ({ t, timelineStatus, isMobile, classes, isCurrentStatus }) => {
  const formattedDuration = timelineStatus.displayDuration();
  return (
    <div className={classes.eventHeaderRow}>
      <div className={classes.timelineStatus}>
        <Typography variant="subtitle1" style={{ flexGrow: 1, opacity: 1 }}>
          {t(`Vehicles.Detail.History.Title.${timelineStatus.state}`)}
        </Typography>
      </div>
      <div className={`${classes.stats} ${classes.headerStats}`}>
        <div className={`${classes.dataField} ${classes.smallDataField}`}>
          <Typography variant="subtitle1">
            {DateService.format(timelineStatus.timestamp, "hh:mm:ss")}
          </Typography>
        </div>
        {!isMobile && (
          <div className={classes.dataField}>
            <Typography variant="subtitle1" color="secondary">
              {isCurrentStatus ? t("Vehicles.Detail.Statuses.current") : formattedDuration}
            </Typography>
          </div>
        )}
      </div>
    </div>
  );
};

TimelineStatusHeaderRow.propTypes = {
  classes: PropTypes.object.isRequired,
  isCurrentStatus: PropTypes.bool.isRequired,
  timelineStatus: PropTypes.oneOfType([PropTypes.instanceOf(TimelineStatus)]).isRequired,
  isMobile: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

// eslint-disable-next-line max-len
export default withStyles(vehicleHistoryStyles)(
  withTranslation("common")(withTheme(TimelineStatusHeaderRow)),
);
